import { Controller } from "@hotwired/stimulus"

// The radios carry a `data-action` attribute of their own - "other-radio" / "other-label" /
// "other-input" - which the handler reads, so the change binding cannot also ride on it and stays
// a plain addEventListener.
export default class extends Controller {
  static get targets() { return ["radio", "otherInput"]; }

  initialize() {
    this.onChange = this.onChange.bind(this);
  }

  connect() {
    if (!this.hasOtherInputTarget) { return; }

    const other = this.radioTargets.find(radio => this.isOther(radio));
    this.otherInputTarget.disabled = !(other && other.checked);

    this.radioTargets.forEach(radio => radio.addEventListener("change", this.onChange));
  }

  disconnect() {
    this.radioTargets.forEach(radio => radio.removeEventListener("change", this.onChange));
  }

  // Multi-select questions use checkboxes on the same targets: toggling any option other than
  // "Other" leaves the free-text field alone.
  onChange(event) {
    const input = event.target;
    if (input.type === "checkbox" && !this.isOther(input)) { return; }

    if (this.isOther(input) && input.checked) {
      this.otherInputTarget.disabled = false;
      this.otherInputTarget.classList.remove("disabled");
      this.otherInputTarget.focus();
    } else {
      this.otherInputTarget.disabled = true;
      this.otherInputTarget.value = "";
    }
  }

  isOther(input) {
    return input.dataset.action === "other-radio";
  }
}
